var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"vh-100 text-center",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"text-center"},[_c('b-button',{attrs:{"variant":"primary","disabled":""}},[_c('b-spinner',{attrs:{"small":"","type":"grow"}}),_vm._v(" Loading... ")],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }